import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import Cookie from 'js-cookie';
import config from 'config';

import { sendAnalytics } from 'utils/analyticsUtils';
import { analyticsConstants } from 'constants/AnalyticsConst';
import SessionView from './SessionView';
import LoaderView from '../LoaderView';
import AgendaContextProvider from './AgendaContextProvider';
import Utils from '../Utils';
import {
    isSessionStartsInMorethan,
    PRE_SESSION_LIVE_TIME,
    ACCESS_ERROR_CHECKING_TIME,
    accessErrorTypes,
    getTimeToSessionStartInMs,
} from './sessionBroadcastUtils';
import FeatureToggleUtils from 'FeatureToggleUtils';
import LiveNowBanner from './LiveNowBanner';
import RegisterAndLoginModal from './RegisterAndLoginModal';
import {
    REGISTER_AND_LOGIN_MODAL_SESSION_PAGE,
    MODAL_OPEN_DELAY,
    SESSION_CONTAINER_ADDITIONAL_SIZE, REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE
} from '../../../constants/Enums';
import EmailLoginContainer_Deprecated from '../EmailLoginContainer_Deprecated';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import { checkAccessErrors } from '../ApiUtil';
import { removeGlobalSessionEntity } from '../../../utils/SnowplowUtils';
import VirtualVenueBanner from '../VirtualVenueBanner';
import AttendeeLogin from '../AttendeeLogin';
import SsoEmailErrorModal from '../SsoEmailErrorModal';
import SessionNotFound from './SessionNotFound';

class SessionPage extends Component {
    static propTypes = {
        session: PropTypes.object,
        settings: PropTypes.object,
        siteConf: PropTypes.object,
        event: PropTypes.object,
        speakers: PropTypes.object,
        serverRendered: PropTypes.bool,
        agendaUrl: PropTypes.string.isRequired,
        fetchSessionData: PropTypes.func.isRequired,
        sendRate: PropTypes.func.isRequired,
        sessionId: PropTypes.number.isRequired,
        isSessionRegistrationEnabled: PropTypes.bool,
        me: PropTypes.object,
        toggleMarker: PropTypes.func.isRequired,
        eventUrls: PropTypes.object.isRequired,
        showEmailLogin: PropTypes.func.isRequired,
        isEmailLoginShown: PropTypes.bool.isRequired,
        showControlPanel: PropTypes.bool,
        topMargin: PropTypes.string,
        showBackgroundColor: PropTypes.bool,
        displayInContainer: PropTypes.bool,
        showCompactLists: PropTypes.bool,
        shouldUseCompactDescription: PropTypes.bool,
        stickSectionsToLeft: PropTypes.bool,
        sessionViewType: PropTypes.string,
        fetchSponsorsByEvent: PropTypes.func,
        toggleSessionRegistrationStatusPerSession: PropTypes.func,
        openCloseTicketSelectionPopUp: PropTypes.func,
        ticketsSelectionData: PropTypes.object.isRequired,
        setSessionFullRegistration: PropTypes.func,
        getUserTicketsByEvent: PropTypes.func,
        setVirtualSessionDetails: PropTypes.func,
        currentVirtualSessionDetails: PropTypes.object,
        setRecordUrl: PropTypes.func,
        recordUrl: PropTypes.string,
        isRingAvailable: PropTypes.bool,
        sessionNotFoundError: PropTypes.oneOfType([
            PropTypes.shape({
                error: PropTypes.string.isRequired,
                errorCode: PropTypes.string.isRequired,
                message: PropTypes.string.isRequired,
            }),
            PropTypes.null,
        ]),
    };

    static defaultProps = {
        isSessionRegistrationEnabled: null,
        showControlPanel: true,
        topMargin: 'double',
        showBackgroundColor: true,
        displayInContainer: true,
        showCompactLists: false,
        shouldUseCompactDescription: false,
        stickSectionsToLeft: true,
        sessionViewType: 'sessionPage'
    };

    state = {
        virtualSessionExist: false,
        isLiveNowBannerOpen: false,
        isRegisterAndLoginModalVisible: false,
        accessErrorType: '',
        analyticData: null,
    };

    toggleShowLiveNowBanner = (isOpen) => {
        this.setState({ isLiveNowBannerOpen: isOpen });
    }

    updateVirtualSessionExist = (virtualSessionExist) => {
        this.setState({ virtualSessionExist: virtualSessionExist });
    }

    fetchDeepSessionData = () => {
        const {
            fetchSponsorsByEvent,
            me: {
                id: isAuthenticated
            },
            event: {
                id: eventId
            },
            getUserTicketsByEvent
        } = this.props;
        this.fetchCurrentSessionData();
        fetchSponsorsByEvent({ id: eventId });
        if (isAuthenticated) {
            getUserTicketsByEvent(eventId, true);
        }
    };

    fetchCurrentSessionData = () => {
        const {
            fetchSessionData,
            sessionId,
            me: {
                id: isAuthenticated
            },
            event: {
                id: eventId
            },
            previewSessionId
        } = this.props;
        fetchSessionData(eventId, sessionId, isAuthenticated, previewSessionId);
    }

    isWebLoginUsed() {
        return !FeatureToggleUtils.isFeatureEnabled('oldLogin');
    }

    async componentDidMount() {
        if (this.props.showBackgroundColor){
            Utils.backgroundColorHandler('add');
        }

        this.fetchDeepSessionData();

        if (this.checkIsNeedToShowRegisterAndLoginModal()) {
            this.openRegisterAndLoginModalWithDelay();
        }

        if (this.isPreliminaryAccessEnabled()) {
            this.checkPreliminaryAccessErrors();
        }
    }

    isPreliminaryAccessEnabled = () => {
        const { event, session, sessionViewType } = this.props;
        const { startDate, startMinute, enableVirtualSession } = session || {};
        const eventTimeZone = event && event['time-zone-id'];

        if (!startDate) return false;

        const timeToSessionStartInMs = getTimeToSessionStartInMs({ startDate, startMinute, eventTimeZone });

        return FeatureToggleUtils.isFeatureEnabled('extendSessionAccessErrorsTiming')
            && timeToSessionStartInMs <= ACCESS_ERROR_CHECKING_TIME
            && isSessionStartsInMorethan(session, PRE_SESSION_LIVE_TIME, eventTimeZone)
            && enableVirtualSession
            && sessionViewType !== 'sessionPreviewWindow';
    };

    checkPreliminaryAccessErrors = async() => {
        const { me, event, sessionId } = this.props;

        if (!me?.id) {
            sendAnalytics('sessionAccessUnauthenticated', {
                sessionId,
                accountId: event['account-id'],
                resultReason: 'notLoggedIn',
                sessionStatus: analyticsConstants.sessionStatus.preSession,
                result: analyticsConstants.result.failure,
            });

            this.setState({ accessErrorType: accessErrorTypes.unauthenticated });
            return;
        }

        try {
            const { isAllowed, errorCode } = await checkAccessErrors(event?.id, sessionId);
            if (!isAllowed) {
                sendAnalytics('sessionAccessUnauthorized', {
                    sessionId,
                    accountId: event['account-id'],
                    resultReason: errorCode,
                    sessionStatus: analyticsConstants.sessionStatus.preSession,
                    result: analyticsConstants.result.failure,
                });

                this.setState({ accessErrorType: errorCode });
            }
        } catch (error) {
            //
        }
    }

    componentDidUpdate(prevProps) {

        if (
            this.props.session && (
                (!prevProps.session) || (this.props.session.id !== prevProps.session?.id))
        ) {
            if (this.isPreliminaryAccessEnabled()) {
                this.checkPreliminaryAccessErrors();
            }
        }

        if (prevProps.enableLoginRegistrationPopUp !== this.props.enableLoginRegistrationPopUp) {
            if (this.checkIsNeedToShowRegisterAndLoginModal()) {
                this.openRegisterAndLoginModalWithDelay();
            }
        }

        // We don't need to show automatic login modal when another login modal is open
        if (this.props.isEmailLoginShown !== prevProps.isEmailLoginShown) {
            if (this.props.isEmailLoginShown && this.modalTimer) {
                clearTimeout(this.modalTimer);
                this.modalTimer = null;
            } else if (!this.props.isEmailLoginShown && this.checkIsNeedToShowRegisterAndLoginModal()) {
                this.openRegisterAndLoginModalWithDelay();
            }
        }
        const switchToAnotherSessionHappened = (
            this.props.session && prevProps.session && (this.props.session?.id !== this.props?.sessionId)
        );
        if (switchToAnotherSessionHappened) {
            removeGlobalSessionEntity(this.props.session);
            this.fetchCurrentSessionData();
        }
    }

    componentWillUnmount() {
        if (this.props.showBackgroundColor) {
            Utils.backgroundColorHandler('remove');
        }

        if (this.modalTimer) {
            clearTimeout(this.modalTimer);
            this.modalTimer = null;
        }
        if (!this.props.previewSessionId){
            setTimeout(() => removeGlobalSessionEntity(this.props.session), 0);
        }
    }

    renderEmailLoginOld() {
        const {
            props: {
                eventUrls: { agendaUrl },
                event: { id, groupId },
            },
        } = this;

        return <EmailLoginContainer_Deprecated
            redirectUrl={agendaUrl}
            eventId={id}
            eventGroupId={groupId}
            headingText="Let's Get Started"
            subHeadingText="Enter the email used for event registration"
        />;
    }

    showRegisterAndLoginModal = (analyticData) => this.setState({
        isRegisterAndLoginModalVisible: true,
        analyticData,
    });

    hideRegisterAndLoginModal = () => this.setState({
        isRegisterAndLoginModalVisible: false
    });

    openRegisterAndLoginModalWithDelay = () => {
        this.modalTimer = setTimeout(() => {
            this.showRegisterAndLoginModal();
            try {
                window.sessionStorage.setItem(REGISTER_AND_LOGIN_MODAL_SESSION_PAGE, true);
            } catch (e) {
                console.warn('Could not access session storage due to privacy settings');
            }
        }, MODAL_OPEN_DELAY - 10000);
    };

    checkIsNeedToShowRegisterAndLoginModal = () => {
        const { me, sessionViewType, siteConf, isEmailLoginShown, enableLoginRegistrationPopUp } = this.props;
        let wasModalShown = false;
        try {
            wasModalShown = window.sessionStorage.getItem(REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE);
        } catch (e) {
            console.warn('Could not access session storage due to privacy settings');
        }
        const isAgendaLoginFlowEnabled = !FeatureToggleUtils.isFeatureEnabled('oldLogin');
        const isAuthenticated = !!me?.id;
        const isWidget = siteConf?.isWidget;

        return (
            isAgendaLoginFlowEnabled &&
            enableLoginRegistrationPopUp &&
            !isAuthenticated &&
            !wasModalShown &&
            sessionViewType !== 'sessionPreviewWindow' &&
            !isWidget &&
            !isEmailLoginShown
        );
    }

    renderEmailLoginNew() {
        const {
            props: {
                eventUrls: { agendaUrl },
            },
        } = this;

        return (
            <AttendeeLogin
                closable
                screen={LoginWidgetScreen.login}
                redirectUrl={agendaUrl}
                hideRegisterAndLoginModal={this.hideRegisterAndLoginModal}
            />
        );
    }

    render() {
        const {
            isLiveNowBannerOpen,
            virtualSessionExist,
            isRegisterAndLoginModalVisible,
            accessErrorType,
            analyticData,
        } = this.state;

        const {
            event,
            session,
            settings,
            serverRendered,
            speakers,
            siteConf,
            sendRate,
            rate,
            feedback,
            isSessionRegistrationEnabled,
            me,
            toggleMarker,
            eventUrls,
            showEmailLogin,
            isEmailLoginShown,
            agendaUrl,
            showControlPanel,
            topMargin,
            displayInContainer,
            showCompactLists,
            shouldUseCompactDescription,
            stickSectionsToLeft,
            sessionViewType,
            toggleSessionRegistrationStatusPerSession,
            openCloseTicketSelectionPopUp,
            ticketsSelectionData,
            setSessionFullRegistration,
            setVirtualSessionDetails,
            currentVirtualSessionDetails,
            clientNavigationAction,
            setScrollToSessionBroadcastAction,
            scrollToBroadcast,
            setRecordUrl,
            recordUrl,
            sessionId,
            setLoginV2SpinnerOrigin,
            setLoginV2OffsetTop,
            loginV2LoadingState,
            isRingAvailable,
            sessionNotFoundError,
        } = this.props;

        if (sessionNotFoundError) {
            return (
                <SessionNotFound />
            );
        }

        if (!session) {
            return (
                <LoaderView />
            );
        }

        if (!this.isWebLoginUsed() && isEmailLoginShown) {
            return this.renderEmailLoginOld();
        }

        const isFeatureSessionVirtualElementEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');
        const { displayLiveNowBanner = true} = settings || {};
        const bannerMarginTop = displayLiveNowBanner && isLiveNowBannerOpen && virtualSessionExist ? SESSION_CONTAINER_ADDITIONAL_SIZE : 0;
        const isOrganizerPreview = Cookie.get(config.previewCookieName);
        const isEventUnpublished = event?.status === 'unpublished';
        const isShowDraftSessionBanner = sessionViewType !== 'sessionPreviewWindow' && !siteConf.isWidget && !isRingAvailable && session?.hidden && isOrganizerPreview;

        const sessionContainerClass = cls(`agenda-view top-agenda-margin-${topMargin}`, {
            'with-banner': session?.imageUrl,
            'agenda-view--session': sessionViewType !== 'sessionPreviewWindow',
        });

        const virtualVenueBannerClass = cls({
            [`virtual-venue-banner--fixed virtual-venue-banner--session virtual-venue-banner--${siteConf.template}`]: !siteConf.isWidget,
        });

        const draftSessionBannerClass = cls('draft-session-banner', {
            'has-session-image': !!session?.imageUrl,
            'is-unpublished': isEventUnpublished,
        });

        return (
            <AgendaContextProvider
                key={sessionId}
                agendaUrl={agendaUrl}
                serverRendered={serverRendered}
                isWidget={!!siteConf.isWidget}
                event={event}
            >
                {session?.imageUrl
                    ? <div className='agenda-banner' style={{marginTop: `${bannerMarginTop}px`}}>
                        <div className="banner-wrapper">
                            {session.imageType === 'image'
                                ? <img src={session.imageUrl} className='banner video-element' crossOrigin=''/>
                                : null}
                            {session.imageType === 'video'
                                ? <video muted playsInline autoPlay loop className='banner video-element' crossOrigin=''>
                                    <source src={session.imageUrl}/>
                                </video>
                                : null}
                        </div>
                    </div>
                    : null}
                {sessionViewType !== 'sessionPreviewWindow' && !siteConf.isWidget
                    ? <VirtualVenueBanner customWrapperClass={virtualVenueBannerClass} />
                    : null}
                {isShowDraftSessionBanner ? (
                    <div className={draftSessionBannerClass}>
                        <div className="container">This is what your session will look like once it’s published</div>
                    </div>
                ) : null}
                {!isRingAvailable && displayLiveNowBanner &&
                <LiveNowBanner
                    currentSessionId={sessionId}
                    showLiveNowBanner={isLiveNowBannerOpen}
                    clientNavigationAction={clientNavigationAction}
                    toggleShowLiveNowBanner={this.toggleShowLiveNowBanner}
                    virtualSessionExist={virtualSessionExist}
                    updateVirtualSessionExist={this.updateVirtualSessionExist}
                    showRegisterAndLoginModal={this.showRegisterAndLoginModal}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    {...{
                        event,
                        me,
                        eventUrls,
                        showEmailLogin,
                        isFeatureSessionVirtualElementEnabled,
                        setVirtualSessionDetails,
                        setRecordUrl,
                        ticketsSelectionData
                    }}
                />}
                <div className={sessionContainerClass}>
                    <SessionView
                        event={event}
                        session={session}
                        settings={settings}
                        siteConf={siteConf}
                        speakers={speakers}
                        serverRendered={serverRendered}
                        sendRate={sendRate}
                        rate={rate}
                        feedback={feedback}
                        showEmailLogin={showEmailLogin}
                        isSessionRegistrationEnabled={isSessionRegistrationEnabled}
                        me={me}
                        toggleMarker={toggleMarker}
                        eventUrls={eventUrls}
                        showControlPanel={showControlPanel}
                        displayInContainer={displayInContainer}
                        showCompactLists={showCompactLists}
                        shouldUseCompactDescription={shouldUseCompactDescription}
                        stickSectionsToLeft={stickSectionsToLeft}
                        sessionViewType={sessionViewType}
                        toggleSessionRegistrationStatusPerSession={toggleSessionRegistrationStatusPerSession}
                        openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                        ticketsSelectionData={ticketsSelectionData}
                        setSessionFullRegistration={setSessionFullRegistration}
                        setVirtualSessionDetails={setVirtualSessionDetails}
                        currentVirtualSessionDetails={currentVirtualSessionDetails}
                        setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
                        scrollToBroadcast={scrollToBroadcast}
                        recordUrl={recordUrl}
                        setRecordUrl={setRecordUrl}
                        showRegisterAndLoginModal={this.showRegisterAndLoginModal}
                        setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                        loginV2LoadingState={loginV2LoadingState}
                        isWebLoginV2Used={this.isWebLoginUsed()}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        accessErrorType={accessErrorType}
                        isPreliminaryAccessEnabled={this.isPreliminaryAccessEnabled()}
                        isRingAvailable={isRingAvailable}
                    />
                    <RegisterAndLoginModal
                        show={isRegisterAndLoginModalVisible}
                        onHide={this.hideRegisterAndLoginModal}
                        eventName={this.props?.event?.name}
                        onLoginClick={showEmailLogin}
                        eventUrls={eventUrls}
                        isEmailLoginShown={isEmailLoginShown}
                        setLoginV2SpinnerOrigin={setLoginV2SpinnerOrigin}
                        loginV2LoadingState={loginV2LoadingState}
                        analyticData={analyticData}
                    />
                </div>
                {this.isWebLoginUsed() && isEmailLoginShown && this.renderEmailLoginNew()}
                {sessionViewType !== 'sessionPreviewWindow' ? <SsoEmailErrorModal /> : null}
            </AgendaContextProvider>
        );
    }
}

export default SessionPage;
